
import { NewsItem } from "@/components/articles/NewsItem";
import { useLanguage } from "@/contexts/LanguageContext";

interface NewsItem {
  id: string;
  title: string;
  content: string;
  image_url?: string;
  created_at: string;
}

interface MemberData {
  id: string;
  full_name: string;
  organization: {
    id: string;
    name: string;
  };
}

interface NewsFeedProps {
  news: NewsItem[];
  memberData: MemberData | null;
  loading: boolean;
}

export const NewsFeed = ({ news, memberData, loading }: NewsFeedProps) => {
  const { t } = useLanguage();
  
  const getPersonalizedTitle = () => {
    if (!memberData) return t('news.latest_news');
    
    const firstName = memberData.full_name.split(' ')[0];
    const greeting = t('news.greeting');
    
    // Replace placeholders with actual values
    return greeting
      .replace('{firstName}', firstName)
      .replace('{organizationName}', memberData.organization.name);
  };

  return (
    <>
      <div className="flex flex-wrap justify-between gap-3 p-4">
        <p className="text-[#111418] tracking-light text-[32px] font-bold leading-tight min-w-72">
          {getPersonalizedTitle()}
        </p>
      </div>
      
      {loading ? (
        <div className="flex items-center justify-center py-8">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-[#1A237E]"></div>
          <span className="ml-2 text-[#2F80ED]">{t('news.loading')}</span>
        </div>
      ) : news.length === 0 ? (
        <div className="text-center py-8">
          <p className="text-[#637588] mb-2">{t('news.no_news')}</p>
          <p className="text-sm text-[#637588]/60">
            {t('news.no_news_subtitle')}
          </p>
        </div>
      ) : (
        <div className="bg-white">
          {news.map((item) => (
            <NewsItem
              key={item.id}
              title={item.title}
              content={item.content}
              imageUrl={item.image_url}
              createdAt={item.created_at}
            />
          ))}
        </div>
      )}
    </>
  );
};
